import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { AuthService } from '@services/auth.service';
import { AccountVerificationComponent } from './account-verification/account-verification.component';
import { AuthRoutingModule } from './auth-routing.module';
import { SvgIconComponent } from 'angular-svg-icon';
import { ButtonDirective } from '@directives/button.directive';

export function initAuthService(authService: AuthService) {
    return () => Promise.all([authService.initializeGoogle(), authService.initializeFacebook()]);
}

@NgModule({
    declarations: [AccountVerificationComponent],
    imports: [CommonModule, AuthRoutingModule, SvgIconComponent, ButtonDirective],
})
export class AuthModule {
    static forRoot(): ModuleWithProviders<AuthModule> {
        return {
            ngModule: AuthModule,
            providers: [
                {
                    provide: APP_INITIALIZER,
                    useFactory: initAuthService,
                    deps: [AuthService],
                    multi: true,
                },
            ],
        };
    }
}
